export default __webpack_public_path__ + "static/About-338d0392b950caad35e0c2554433b74c.png";